import React from 'react';

import Header from '../../components/Header';

import Slideshow from './sections/Slideshow';
import AboutUs from './sections/AboutUs';
import WhatWeDo from './sections/WhatWeDo';
import Portfolio from './sections/Portfolio';
import Contact from './sections/Contact';

import Footer from '../../components/Footer';

const Home: React.FC = () => {
  return (
    <>
      <Header isReferable />

      <Slideshow />
      <AboutUs />
      <WhatWeDo />
      <Portfolio />
      <Contact />

      <Footer />
    </>
  );
};

export default Home;
